const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// /app — Telegram Mini App (MP xodim ilovasi). Alohida chunk: admin panel kodi
// (App.tsx, Tailwind) telefonga yuklanmaydi va aksincha.
const path = window.location.pathname;
if (path === '/app' || path.startsWith('/app/')) {
  import('./miniapp').then((m) => m.mountMiniApp(rootElement));
} else {
  import('./adminEntry').then((m) => m.mountAdmin(rootElement));
}

export {};
